import {
  LOCAL_SERVICE_QUOTE_FLOW_TYPE,
  LOCAL_SERVICE_QUOTE_PRESET,
} from "../constants/localServiceQuotePreset";

const cloneJson = (value) => JSON.parse(JSON.stringify(value));

const slugify = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const campaignSlugFromUrl = (inputUrl) => {
  if (!inputUrl) return "";
  try {
    const url = new URL(inputUrl);
    return slugify(url.pathname.split("/").filter(Boolean).join("-"));
  } catch (err) {
    return "";
  }
};

const appendQueryParams = (inputUrl, params) => {
  if (!inputUrl) return "";
  try {
    const url = new URL(inputUrl);
    Object.entries(params).forEach(([key, value]) => {
      if (value) url.searchParams.set(key, value);
    });
    return url.toString();
  } catch (err) {
    return inputUrl;
  }
};

export const isLocalServiceQuoteFlow = (value) => {
  if (!value) return false;
  if (typeof value === "string") {
    return value.trim().toLowerCase() === LOCAL_SERVICE_QUOTE_FLOW_TYPE;
  }
  return (
    String(value?.templateMeta?.flowType || "")
      .trim()
      .toLowerCase() === LOCAL_SERVICE_QUOTE_FLOW_TYPE
  );
};

export const buildLocalServiceQuoteBlueprint = (business = null) => {
  const preset = cloneJson(LOCAL_SERVICE_QUOTE_PRESET);
  const businessName = String(business?.name || "").trim();

  preset.templateMeta.companyName = businessName;
  preset.templateMeta.recruiterName = businessName;
  // Leave service area blank so operators do not accidentally publish their
  // registered address as the coverage area.
  preset.templateMeta.location = "";

  return preset;
};

export const buildTrackedQuoteLinks = (publicUrl, businessName = "") => {
  if (!publicUrl) return [];
  const baseSlug = campaignSlugFromUrl(publicUrl) || slugify(businessName) || "local-service";
  const campaignBase = baseSlug.endsWith("-quote") ? baseSlug : `${baseSlug}-quote`;
  return [
    { key: "canonical", label: "Canonical", url: publicUrl },
    {
      key: "facebook",
      label: "Facebook",
      url: appendQueryParams(publicUrl, {
        utm_source: "facebook",
        utm_medium: "social",
        utm_campaign: campaignBase,
      }),
    },
    {
      key: "instagram",
      label: "Instagram",
      url: appendQueryParams(publicUrl, {
        utm_source: "instagram",
        utm_medium: "social",
        utm_campaign: campaignBase,
      }),
    },
    {
      key: "tiktok",
      label: "TikTok",
      url: appendQueryParams(publicUrl, {
        utm_source: "tiktok",
        utm_medium: "social",
        utm_campaign: campaignBase,
      }),
    },
    {
      key: "whatsapp",
      label: "WhatsApp",
      url: appendQueryParams(publicUrl, {
        utm_source: "whatsapp",
        utm_medium: "direct_message",
        utm_campaign: campaignBase,
      }),
    },
    {
      key: "nextdoor",
      label: "Nextdoor",
      url: appendQueryParams(publicUrl, {
        utm_source: "nextdoor",
        utm_medium: "social",
        utm_campaign: campaignBase,
      }),
    },
  ];
};
